import React, { useEffect, useState } from "react";
import TickIcon from "../../assets/icons/tick.svg2";
import SendIcon from "../../assets/icons/send.svg2";
import { Row } from "react-bootstrap";
import EngineerVisitIcon from "../../assets/icons/engineer.svg2";
import { Link } from "react-router-dom";
import JsonCollapse from "../Builder/Components/JsonCollapse";
import { proxyAPI } from "../proxyAPI";
import TokenEditor from "../Builder/Components/TokenEditor";
import { BroadcastType } from "../store/slices/broadcastSlice";
import TemplateDetail from "./TemplateDetail";
import { toast } from "react-toastify";
import ErrorBoundary from "../Builder/Components/ErrorBoundary";
import ScheduleSettings from "../Schedulers/ScheduleSettings";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendar } from "@fortawesome/free-solid-svg-icons";

export default function BroadcastTemplateDetails({
  selectedTemplate,
}: {
  selectedTemplate: BroadcastType;
}) {
  const [numberOfContacts, setNumberOfContacts] = useState(0);
  const [numberOfGroups, setNumberOfGroups] = useState(0);

  const loadSendList = async () => {
    const sendList = await proxyAPI({
      prefix: "contacts/v1",
      url: `/send-list/${selectedTemplate.SendList}`,
    });
    if (sendList) {
      setNumberOfGroups(sendList.contactSets.length);
    }
    const sendlistResponse = await proxyAPI({
      prefix: "contacts/v1",
      method: "POST",
      url: `find`,
      body: {
        filters: [],
        paginate: {
          order: "desc",
          order_by: "created_at",
          page: 0,
          perPage: 1,
        },
        fields: { uuids: [], cards: true, channels: true },
        sendListOptions: {
          uuids: [selectedTemplate.SendList],
          ignore: false,
        },
      },
    });
    if (sendlistResponse) {
      setNumberOfContacts(sendlistResponse.pagination.total);
    }
  };

  useEffect(() => {
    if (selectedTemplate.SendList) {
      loadSendList();
    } else {
      setNumberOfContacts(0);
      setNumberOfGroups(0);
    }
  }, [selectedTemplate.Uuid]);

  const pushBroadcast = async () => {
    const data = await proxyAPI({
      prefix: "logic/workflows/api",
      url: "broadcasters/push",
      method: "POST",
      body: {
        Uuid: selectedTemplate.Uuid,
        // SendList: selectedTemplate.SendList,
      },
    });
    if (data) {
      toast.success(data.message);
    }
  };

  return (
    <div className="my-3">
      <div
        className={`w-75 h-100 px-0  text-start rounded-3 position-relative `}
      >
        <div className="d-flex align-items-center">
          <div className="bg-purple-gradient rounded-circle me-3">
            <EngineerVisitIcon width={60} />
          </div>
          <div className="me-3">
            <h3 className="text-black fw-bold">{selectedTemplate.Label}</h3>
            <div className="text-secondary small text-xxl-start text-break">
              {selectedTemplate.Description}
            </div>
          </div>
        </div>
      </div>
      <div className="fw-bold my-4">
        This template will setup the following for you:
      </div>
      <Row>
        <div className="col-6">
          <ErrorBoundary>
            <TemplateDetail
              Icon={TickIcon}
              label="Industry"
              value={selectedTemplate.TagsMap?.industry?.join(", ") ?? ""}
            />
          </ErrorBoundary>
        </div>
        <div className="col-6">
          <ErrorBoundary>
            <TemplateDetail
              Icon={TickIcon}
              label="Category"
              value={selectedTemplate.TagsMap?.category?.join(", ") ?? ""}
            />
          </ErrorBoundary>
        </div>
        <div className="col-6">
          <ErrorBoundary>
            <TemplateDetail
              Icon={TickIcon}
              label="Folder"
              value={selectedTemplate.TagsMap?.folder?.join(", ") ?? ""}
            />
          </ErrorBoundary>
        </div>
        <div className="col-6">
          <TemplateDetail
            Icon={TickIcon}
            label="Reference"
            value={selectedTemplate.Reference}
          />
        </div>

        <div className="col-6">
          <TemplateDetail
            Icon={TickIcon}
            label="Status"
            value={selectedTemplate.Status}
          />
        </div>

        <div className="col-6">
          <TemplateDetail
            Icon={TickIcon}
            label="Email"
            value={selectedTemplate.Email}
          />
        </div>

        <div className="col-6">
          <TemplateDetail
            Icon={TickIcon}
            label="Method"
            value={selectedTemplate.CommsMethod}
          />
        </div>

        <div className="col-6">
          <TemplateDetail
            Icon={TickIcon}
            label="Channels"
            value={selectedTemplate.Messages.map(
              (message) => message.Channel
            ).join(", ")}
          />
        </div>

        <div className="col-6">
          <TemplateDetail
            Icon={TickIcon}
            label="Contacts"
            value={numberOfContacts.toString()}
          />
        </div>
        <div className="col-6">
          <TemplateDetail
            Icon={TickIcon}
            label="Groups"
            value={numberOfGroups.toString()}
          />
        </div>

        {selectedTemplate.IsFileImport && (
          <>
            <div className="fw-bold mt-4 mb-2">File Import:</div>

            <div className="col-6">
              <TemplateDetail
                Icon={TickIcon}
                label="Used headers"
                value={selectedTemplate.FileImportHeader?.join(", ") ?? ""}
              />
            </div>
          </>
        )}
      </Row>

      {/* <div className="fw-bold mt-4 pt-2">Please note:</div>
      <span className="text-secondary">
        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
      </span> */}
      <div className="d-flex justify-content-start my-5">
        <Link
          to={`/library/broadcast/${selectedTemplate.Uuid}/messages`}
          className="btn bg-colored-reverse rounded-pill me-2"
        >
          <div className="d-flex align-items-center ">
            <TickIcon width={25} className=" white  p-1" />
            <h5 className="my-0 mx-2 text-white">Use this template</h5>
          </div>
        </Link>
        <button
          className="btn bg-colored-reverse rounded-pill"
          onClick={pushBroadcast}
        >
          <div className="d-flex align-items-center ">
            <SendIcon width={25} className=" white p-1" />
            <h5 className="my-0 mx-2 text-white">Send</h5>
          </div>
        </button>
        <ScheduleSettings
          broadcasterUuid={selectedTemplate.Uuid}
          button={
            <div className="btn bg-colored-reverse rounded-pill d-inline-block p-2 px-3 text-white fs-5 h-100">
              <div className="d-flex align-items-center ">
                <FontAwesomeIcon icon={faCalendar} />
                <h5 className="my-0 mx-2  text-white">Schedule send</h5>
              </div>
            </div>
          }
        />
      </div>
      <JsonCollapse json={selectedTemplate} />
    </div>
  );
}
